import './App.css';
import Navbar from './Components/Navbar';
import Image from './Components/Image';

function App() {
  return (
    <div>
      <Navbar></Navbar>
      <Image></Image>
    </div>
  );
}

export default App;
